import { render, staticRenderFns } from "./list-columns.vue?vue&type=template&id=348d6b43&scoped=true&"
import script from "./list-columns.vue?vue&type=script&lang=js&"
export * from "./list-columns.vue?vue&type=script&lang=js&"
import style0 from "./list-columns.vue?vue&type=style&index=0&id=348d6b43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348d6b43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348d6b43')) {
      api.createRecord('348d6b43', component.options)
    } else {
      api.reload('348d6b43', component.options)
    }
    module.hot.accept("./list-columns.vue?vue&type=template&id=348d6b43&scoped=true&", function () {
      api.rerender('348d6b43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shells/list/list-columns.vue"
export default component.exports